document.addEventListener('DOMContentLoaded' , () =>{	
	//counsel-view-page	
	if(document.querySelector('.counsel-view-page')){
		//전문가가 추천하는 영양제
		$('.recommend .prd-list').slick({
			dots:false,
			arrows:false,
			variableWidth: true,
			slidesToShow: 4,
		});
	}
});
